import axios from './Axios';
import { getAxiosHeader, getAxiosHeaderForm, urlImportRelease } from './AxiosVars';

export type ImportPortal = {
    id?: number;
    idFirma?: number;
    idQuelle?: number;
    isBestand?: boolean;
    isImportAttr?: boolean;
    isOnlyNewCar?: boolean;
    isOnlyUpdate?: boolean;
    name?: string;
    others?: string;
    pwd?: string;
};

export function addQuelle(idFirma: number, idUser: number, idSchnittstelle: number, data: Omit<ImportPortal, 'id' | 'idFirma' | 'idQuelle'>) {
    return axios({
        title: 'Hinzufügen der Import-Schnittstelle',
        method: 'post',
        url: `${urlImportRelease}/import/v2/addSchnittstelle/firma/${idFirma}/user/${idUser}/${idSchnittstelle}`,
        data,
        headers: getAxiosHeaderForm(),
    });
}

export function getProtoImp(idFirma: number) {
    const url = urlImportRelease + '/import/v1/status/' + idFirma + '/current';
    return axios({
        title: 'Abrufen der Importprotokolle',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function getSchnittstelle(idFirma: number) {
    const url = urlImportRelease + '/import/v1/status/' + idFirma + '/config';
    return axios({
        title: 'Abrufen der Import-Schnittstelle',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function checkVINBeforeImport(vin: string) {
    const url = urlImportRelease + '/import/v1/check/vin';
    return axios({
        title: 'Prüfen der VIN',
        method: 'post',
        url: url,
        data: 'vin=' + vin,
        headers: getAxiosHeader(),
    });
}
